import { RequestStatus } from 'common/enum';

const FiltersState: FiltersStateType = {
  resReq: {
    keyword: '',
    city: '',
    county: [],
    status: [
      RequestStatus.REQUEST,
      RequestStatus.PARTIAL,
      RequestStatus.ACCEPTED,
      RequestStatus.PENDING,
      RequestStatus.FORWARDED,
      RequestStatus.RECEIVED,
    ],
    limit: '10',
    page: 1,
    countyOptions: [],
    statusOptions: [],
  },
  users: {
    keyword: '',
    limit: '10',
    page: 1,
  },
  organization: {
    city: '',
    keyword: '',
    limit: '10',
    page: 1,
    type: '',
    orgTypeOptions: [],
    cityOptions: [],
  },
};

export default FiltersState;
